export const formatZScore = (num: number) => num.toFixed(2)
